<template>
    <table>
        <caption class="sr-only">Box Contents</caption>
        <thead>
            <tr>
                <th scope="col" v-html="$t('giftwrapping.qty.heading')"></th>
                <th scope="col" v-html="$t('giftwrapping.product.heading')"></th>
                <th scope="col" v-html="$t('giftwrapping.price.heading')"></th>
            </tr>
        </thead>
        <tbody>
            <tr :class="totalAddedProducts > 0 ? 'added' : ''">
                <td class="selected-quantity align-top" v-html="$t('giftwrapping.quantity')"></td>
                <td class="selected-item-description pr-3" v-html="$t('giftwrapping.description')"></td>
                <td class="selected-item-price text-left align-top" v-html="$t('giftwrapping.pricevalue')"></td>
            </tr>
            <tr v-for="product in boxProducts" :class="totalAddedProducts > 0 ? 'added' : ''">
                <td role="rowheader" class="selected-quantity align-top" v-html="product.qty"></td>
                <td class="selected-item-description pr-3" v-html="product.name"></td>
                <td class="selected-item-price text-left align-top" v-html="getProductTotalPrice(product)"></td>
                <td class="remove-btn-cell text-right align-top">
                    <button :data-product-id="product.id" 
                        @keydown="(e) => { triggerRemove(e, product, oldEventBus, boxProducts) }" 
                        class="ml-auto p-0 icon-close remove-product" aria-label="remove-product">
                            <SvgHelper :icon="'close'" :svgtitle="'close'" :decorative="true"
                                @click="oldEventBus.$emit('removeProductFromBox', product.id)">
                            </SvgHelper>
                    </button>
                </td>
            </tr>
        </tbody>
    </table>
</template>

<script setup>
import { SvgHelper } from "@/components/helper/util"
import { triggerRemove } from "@/components/helper/byos/byosHelper"

import { mapGetters } from "@/store/helper/vuex";
import { EventBus as oldEventBus } from "@/scripts/event-bus.js";

const { boxProducts, totalAddedProducts, pdict } = mapGetters();

const getProductTotalPrice = (product) => {
    let totalPriceValue = (product.priceValue * product.qty).toFixed(2);
    return pdict.value.currencyFormat.replace(pdict.value.currencyFormatValuePlaceholder, totalPriceValue);
}

</script>